export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manarwb.d73c9675.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};